import { Interaction } from './interaction';
import { VectorLayer } from '../vector_layer';

import Collection from 'ol/Collection';
import SelectInteraction from 'ol/interaction/Select';

class Select extends Interaction {

	constructor(interaction) {
		super(interaction);
	}
	
	addSelectEventHandler(handler) {
		const key = this.interaction.on('select', ({selected}) => handler(selected[0]));
		return () => unByKey(key);	
	} 
	
	clear() {
		this.interaction.getFeatures().clear();
	}
}

const select = (layer, style) => {
	if( layer instanceof VectorLayer ) {
		const features = new Collection();	        
		const select = new SelectInteraction({
	    	layers: [layer.layer],
	        style: style,
	        features: features
		});
		   	
	   	return new Select( select );	
	}
}

export {
	select, Select
}
